import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var ExternalLinkIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ _jsxs("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M6.5.75A.75.75 0 0 1 7.25 0H16v8.75a.75.75 0 0 1-1.5 0V2.562L7.53 9.53a.75.75 0 1 1-1.06-1.06l6.97-6.97H7.25A.75.75 0 0 1 6.5.75Z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M3 2h2v1.5H3A1.5 1.5 0 0 0 1.5 5v8A1.5 1.5 0 0 0 3 14.5h8a1.5 1.5 0 0 0 1.5-1.5v-2H14v2a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Z"
                })
            ]
        }) : /*#__PURE__*/ _jsxs("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M23.306 13.056a.75.75 0 0 1-.75-.75V2.504L10.03 15.03a.75.75 0 1 1-1.06-1.06L21.44 1.5h-9.69a.75.75 0 0 1 0-1.5h11.556a.75.75 0 0 1 .75.75v11.556a.75.75 0 0 1-.75.75Z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M4.75 5.25A3.25 3.25 0 0 0 1.5 8.5v10.75a3.25 3.25 0 0 0 3.25 3.25h11A3.25 3.25 0 0 0 19 19.25v-6.362a.75.75 0 1 1 1.5 0v6.362A4.75 4.75 0 0 1 15.75 24h-11A4.75 4.75 0 0 1 0 19.25V8.5a4.75 4.75 0 0 1 4.75-4.75h6.5a.75.75 0 0 1 0 1.5h-6.5Z"
                })
            ]
        })
    }));
};
